import { render } from "./transfer_cashier_body.vue?vue&type=template&id=7a070c44"
import script from "./transfer_cashier_body.vue?vue&type=script&lang=js"
export * from "./transfer_cashier_body.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__